import Swiper, { Scrollbar, Lazy } from 'swiper';

Swiper.use([Scrollbar, Lazy]);

const selectors = {
  swiper: '.js-products-swiper',
  scrollbar: '.js-products-swiper-scrollbar',
};

const productsSlider = () => {
  const container = document.querySelector(selectors.swiper);
  if (container === null) return;

  const swiper = new Swiper(container, {
    slidesPerView: 2,
    initialSlide: 1,
    centeredSlides: true,

    breakpoints: {
      769: {
        initialSlide: 0,
        centeredSlides: false,
        slidesPerView: 2.9,
      },
    },

    // lazy
    lazy: {
      loadPrevNext: true,
    },
    watchSlidesProgress: true,
    loadOnTransitionStart: true,
    watchSlidesVisibility: true,
    preloadImages: false,

    scrollbar: {
      el: selectors.scrollbar,
      draggable: true,
    },
  });
};

export default productsSlider;
